<template>
<svg xmlns="http://www.w3.org/2000/svg" width="9" height="6"><g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-width="2"><path d="M.996 1.496 4.5 5M8.004 1.496 4.5 5"/></g></svg>
</template>

<script>
export default {
  name: 'ArrowDown'
}
</script>
